var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkBlock3Ic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.5429 69.5026H7.45714V70.9455H72.5429V69.5026Z",
    fill: "#1D4B48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5429 24.0588H7.45714V25.5017H72.5429V24.0588Z",
    fill: "#1D4B48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1452 8.9099H28.8442V10.3528H63.1452V8.9099Z",
    fill: "#1D4B48"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9362 6H68.5076V74H69.9362V6Z",
    fill: "#1D4B48"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4924 20.6278H10.0638V74H11.4924V20.6278Z",
    fill: "#1D4B48"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8913 20.6278H31.4627V28.2253H32.8913V20.6278Z",
    fill: "#1D4B48"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9392 25.5017H31.4627V8.9099H69.9362V25.5017H69.9392ZM32.8943 24.0588H68.5106V10.3528H32.8943V24.0558V24.0588Z",
    fill: "#1D4B48"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5372 40.6507H10.0638V24.0588H48.5372V40.6507ZM11.4954 39.2078H47.1116V25.5047H11.4954V39.2078Z",
    fill: "#1D4B48"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9362 24.0588H47.1086V40.6507H69.9362V24.0588Z",
    fill: "#1D4B48"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9362 54.3537H31.4627V70.9455H69.9362V54.3537Z",
    fill: "#1D4B48"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8943 70.9455H10.0638V54.3537H32.8914V70.9455H32.8943ZM11.4954 69.5026H31.4657V55.7996H11.4954V69.5026Z",
    fill: "#1D4B48"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8943 39.2047H10.0638V55.7996H32.8943V39.2047Z",
    fill: "#1D4B48"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2933 55.7996H31.4658V39.2078H54.2933V55.7996ZM32.8943 54.3537H52.8647V40.6477H32.8943V54.3537Z",
    fill: "#1D4B48"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9401 55.8005H52.8647V39.2078H69.9401V55.8005ZM54.2934 54.3545H68.5085V40.6477H54.2934V54.3545Z",
    fill: "#1D4B48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkBlock3Ic);
export default __webpack_public_path__ + "static/media/workBlock3_ic.aae2b0c0d5074b03dbe518113fc0f248.svg";
export { ForwardRef as ReactComponent };